import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "file-txt content-right-attachment-download-button-preview" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 添付画像をまとめて ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "line"
}, " ダウンロード ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_1, _hoisted_4)), [
    [
      _directive_tooltip,
      { content:'公開前のため、DLできない仕様になっています', classes: 'content-right-attachment-download-button-preview-width' },
      void 0,
      { right: true }
    ]
  ])
}